module.exports = __webpack_public_path__ + "img/test-img.d21afe9b.png";